import { useT } from '@transifex/react';

import { IneligibleTemplate } from './IneligibleTemplate';

// The `Eligibility_Terminated` rendering of NotEligibleScreen — stylos's
// IneligibleInsurancePage (an IneligibleTemplate with the insurance copy).
export function InsuranceTerminatedTemplate() {
  const t = useT();
  return (
    <IneligibleTemplate
      title={t('Sorry, your insurance doesn’t cover Vida')}
      subtitle={t(
        "If this doesn't seem right or if you need more assistance, our Vida support is here to help."
      )}
    />
  );
}
